
import { schema } from "./types";
import { IAutomationAppComponent, IAutomationObject } from "../../../types";
import SystemPanel from './SystemPanel'
import { OverviewPanel } from './OverviewPanel'
import { OperatorPanel } from './OperatorPanel'
import { ConfigurationPanel } from './ConfigurationPanel'
import { HiOutlineOfficeBuilding } from 'react-icons/hi';
import { ParameterPanel } from "./ParameterPanel";
import CreatePanel from "./CreatePanel";
import SideviewPanel from "./SideviewPanel";
import InsightsPanel from './InsightsPanel';
import { schema as schemaRoomAutomation } from '../P_RoomAutomation/types'

export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: true,
    Icon: HiOutlineOfficeBuilding,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    ParameterPanel: ParameterPanel,
    SystemPanel: SystemPanel,
    SideViewPanel: SideviewPanel,
    InsightsPanel: InsightsPanel,
    createConfig: {
        group: 'Spaces',
        name: "Street 15, 23435 Somewhere",
        description: "Building",
        panel: CreatePanel,
        defaultState: { showLocation: true },
        defaultProperties: [
            { key: 'ShowLocation', value: 'true' },
        ]
    },
    addAppFilter: (app: IAutomationObject) => app.schema === schemaRoomAutomation 
    || app.schema.startsWith('AutomationApps.Plants.Coolings.')
    || app.schema.startsWith('AutomationApps.Plants.AirHandlingUnits.')
    || app.schema.startsWith('AutomationApps.Plants.Heatings.')
    || app.schema.startsWith('AutomationApps.Utils.EnergyOverview')
    || app.schema.startsWith('AutomationApps.SubPlants.OutsideConditions.')
    || app.schema.startsWith('AutomationApps.SubPlants.SP_Cabinet.')
    || app.schema.startsWith('AutomationApps.Plants.Commons.')
}